module.exports = __webpack_public_path__ + "1.4.15-unryo/img/snmp.808d2252.svg";